import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Error } from '../../models/error.interface';

@Injectable({providedIn: 'root'})
export class CustomErrorHandlerService {
  constructor() { }


  tryParseError(error: any): any {
    try {
      // If this is already a dependency object, return it as-is
      if (error && error.hasDependencies) {
        return error;
      }
      
      // Check if error.error is a string that needs parsing
      if (typeof error.error === 'string') {
        try {
          const parsedError = JSON.parse(error.error);
          if (parsedError && parsedError.hasDependencies) {
            return parsedError;
          }
        } catch (parseError) {
        }
      }
      
      // Check if this is a dependency error - preserve the original structure
      if (error.error && error.error.hasDependencies) {
        return error.error; // Return the original dependency JSON
      }

      // Preserve structured validation payloads (e.g. { errors: ['KEY', ...] } from a 400)
      // so callers can surface each specific message instead of a generic error.
      if (error.error && Array.isArray(error.error.errors)) {
        return error.error;
      }
      if (typeof error.error === 'string') {
        try {
          const parsedValidation = JSON.parse(error.error);
          if (parsedValidation && Array.isArray(parsedValidation.errors)) {
            return parsedValidation;
          }
        } catch (parseError) {
        }
      }

      // For all other errors, use the existing logic
      const response = new Error(error.status, error.statusText, error.message);
      this.showErrorMessage(response);

      return response;
    } catch (ex) {
      const response = new Error(400, "Unknown Error", "Unknown error occurred");
      return response;
    }
  }

  showErrorMessage(error: Error){
    //implement notification plugin
  }
}
